import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\nquery($dealerId: Int!) {\n    findGoodsDisplayOrderByDealerId(\n      dealerId: $dealerId,\n    ) {\n      dealerId\n      displayOrders\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $goodId: Int!, $order: Int!) {\n    updateGoodDisplayOrder(\n      dealerId: $dealerId,\n      goodId: $goodId,\n      order: $order\n    ) {\n      id\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $orders: [Int!]!) {\n    updateDisplayOrder(\n      dealerId: $dealerId,\n      orders: $orders\n    ) {\n      id\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $schoolIds: [Int!]!) {\n    updateDealerSchools(\n      dealerId: $dealerId,\n      schoolIds: $schoolIds\n    ) {\n      area {\n        cityCode\n        createdAt\n        id\n        ing\n        lat\n        levelType\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        mergerName\n        name\n        parentId\n        pinyin\n        shortName\n        updatedAt\n        zipCode\n      }\n      dealers {\n        id\n        realname\n        storeName\n        status\n        user {\n          phone\n        }\n      }\n      areaId\n      createdAt\n      id\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      name\n      status\n      updatedAt\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $goodIds: [Int!]!) {\n    removeGoodsFromDealer(\n      dealerId: $dealerId,\n      goodIds: $goodIds\n    )\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $goods: [GoodProportionInput!]!) {\n    assignGoodsToDealer(\n      dealerId: $dealerId,\n      goods: $goods\n    )\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var assignGoodsToDealer = gql(_templateObject());
export var removeGoodsFromDealer = gql(_templateObject2());
export var updateDealerSchools = gql(_templateObject3());
export var updateDisplayOrder = gql(_templateObject4());
export var updateGoodDisplayOrder = gql(_templateObject5());
export var findGoodsDisplayOrderByDealerId = gql(_templateObject6());